// extracted by mini-css-extract-plugin
export var completionBody = "_gk-2";
export var completionCard = "_gk-0";
export var completionFooter = "_gk-3";
export var completionTitle = "_gk-1";